import {
  LeadAnalysisDirectReport,
  ReportType,
  SettingsPeriod
} from "@/entities/reporting/types";
import { createBreadcrumbsContext } from "@/components/shared/BaseBreadcrumbsContext";
import { UserData } from "@/entities/users/types";

const {
  BreadcrumbsProvider: BaseConversionProvider,
  useBreadcrumbs: useLeadAnalysisBreadcrumbs
} = createBreadcrumbsContext<LeadAnalysisDirectReport>();

export const LeadAnalysisBreadcrumbsProvider: React.FC<{
  children: React.ReactNode;
  leadUser: UserData | undefined;
  period?: SettingsPeriod;
  enableDirectReportsData?: boolean;
}> = ({ children, leadUser, period, enableDirectReportsData = true }) => (
  <BaseConversionProvider
    leadUser={leadUser}
    period={period}
    reportType={ReportType.LEAD_ANALYSIS}
    defaultPeriod={SettingsPeriod.LAST_12_MONTHS}
    responseKey="leadsAnalysis"
    enableDirectReportsData={enableDirectReportsData}
  >
    {children}
  </BaseConversionProvider>
);

export { useLeadAnalysisBreadcrumbs };
